import {WidgetConfiguration} from '@feature/widget-configs/models/widget-configuration';
import {ITable} from '@common/models/table';
import {SelectItem} from 'primeng/api';

export * from '@feature/pma-entity/pma-entity-types';

export function selectItemsWithNoneOption(items: SelectItem[]) {
  const all: SelectItem[] = [
    {
      label: 'None',
      value: null,
      disabled : true
    }
  ];
  return all.concat(items);
}

export interface PmaDocumentCentreWidgetConfigurationCategory {
  DocumentCentreCategoryUri: number;
  Show: boolean;
  AllowUpload: boolean;
  Name: string;
}

export function isExternal(config: WidgetConfiguration) {
  return config.widgetTypeId !== 'MojoDocumentCentre';
}

export class PmaDocumentCenterConfigurationRelatedRecordsFilter {
  IncludeChildren: boolean;
  IncludeParents: boolean;
}

export class PmaDocumentCentreConfiguration {
  Limit: number;
  RelatedRecordsFilter: PmaDocumentCenterConfigurationRelatedRecordsFilter;
  SelectedCategories: PmaDocumentCentreWidgetConfigurationCategory[];
}

export interface SavePmaDocumentCentreWidgetConfigurationRequest {
  WidgetConfiguration: WidgetConfiguration;
  DocumentCentreWidgetConfigurationModel: PmaDocumentCentreConfiguration;
}
export interface ExpiryType {
  label: string;
  toMins(val: number);
  fromMins(val: number);
}

export const expiryTypeYears: ExpiryType = {
  label: 'Years',
  toMins: (v: number) => v * 525600,
  fromMins: (v: number) => v / 525600
}

export const expiryTypeDays: ExpiryType = {
  label: 'Days',
  toMins: (v: number) => v * 1440,
  fromMins: (v: number) => v / 1440
}

export const expiryTypes: ExpiryType[] = [
  expiryTypeDays,
  expiryTypeYears
];


export interface PmaDocumentCentreCategory {
  key: any;
  name: string;
  durationMins?: number;
  expiryType?: ExpiryType;
}

export const nonePmaDocumentCentreCategory: PmaDocumentCentreCategory = {
  key: null,
  name: 'None',
}


export interface PmaDocumentCentreWidget {
  id: number;
  loading: boolean;
  table: ITable;
}

export class UploadRequest {
  file: File;
  model: any;
}

export interface PmaDocumentCentreDocumentProperties {
  DocumentKey: any;
  Category: any;
  ExpiryDate: Date;
  Visibility: [];
  Description: string;
  LinkedTo: string;
  Reference: string;
  FileName: string;
  FileSize: number;
  DateAdded: Date;
  AddedBy: string;
}

export interface SavePmaDocumentCentreDocumentPropertiesRequest {
  EntityKey: any;
  Category: any;
  ExpiryDate: Date;
  Visibility: [];
  Description: string;
}



export interface PmaDocumentCentreWidgetConfig {
  IncludeParents: boolean;
  IncludeChildren: boolean;
  Limit: number;
}
